var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isView)?_c('ButtonDropdown',{attrs:{"button-label":_vm.t('monitoringReceiver.addButton', { type: _vm.t(_vm.webhookType.label) }),"dropdown-options":_vm.options,"size":"sm"},on:{"click-action":_vm.add}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }